module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-capsule', {
    attrs: {
      "formTitle": _vm.$t('webheader.back_office'),
      "writable": false
    }
  }, [_c('template', {
    slot: "formcontent"
  }, [_vm._v("\n      Workflow document "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    Workflow paiement\n  ")])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e6a6993c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6a6993c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statistics/BackOffice.vue
// module id = 2520
// module chunks = 2